import { useEffect } from 'react'
import { create } from 'zustand'

interface BreadcrumbLabelState {
  labels: Record<string, string>
  setLabels: (labels: Record<string, string>) => void
}

/**
 * Labels a page registers for its own path trail (for example the school name). Held in a
 * store rather than router state: rewriting the location from an effect raced with
 * search-param updates and dropped the wizard's `step` and `year`.
 */
export const useBreadcrumbLabelStore = create<BreadcrumbLabelState>(set => ({
  labels: {},
  setLabels: labels => set({ labels }),
}))

/** Register `{ '/path': 'Label' }` entries for the lifetime of the calling page. */
export function useRegisterBreadcrumbLabels(labels: Record<string, string> | null) {
  const setLabels = useBreadcrumbLabelStore(s => s.setLabels)
  const key = labels ? JSON.stringify(labels) : ''
  useEffect(() => {
    setLabels(key ? (JSON.parse(key) as Record<string, string>) : {})
    return () => setLabels({})
  }, [key, setLabels])
}
